export interface CompanyUser {
  id: string;
  name: string;
  email: string;
  role: 'Administrator' | 'Project Manager' | 'Viewer';
}

export interface ActivityLogEntry {
  id: string;
  timestamp: string;
  action: string;
  affectedItem: string;
}

export const mockCompanyUsers: CompanyUser[] = [
  {
    id: '1',
    name: 'Alice Johnson',
    email: 'alice.a@builders.com',
    role: 'Administrator',
  },
  {
    id: '2',
    name: 'Bob Williams',
    email: 'bob.w@builders.com',
    role: 'Project Manager',
  },
  {
    id: '3',
    name: 'Charlie Brown',
    email: 'charlie.b@builders.com',
    role: 'Viewer',
  },
];

export const mockActivityLog: ActivityLogEntry[] = [
  {
    id: '1',
    timestamp: '2023-10-27 14:52:15',
    action: 'Property Update',
    affectedItem: '123 Maple Street',
  },
  {
    id: '2',
    timestamp: '2023-10-27 13:05:42',
    action: 'Template Created',
    affectedItem: '"Modern Finishings"',
  },
  {
    id: '3',
    timestamp: '2023-10-28 18:22:51',
    action: 'Security Change',
    affectedItem: 'Password Changed',
  },
  {
    id: '4',
    timestamp: '2023-10-28 09:15:33',
    action: 'User Login',
    affectedItem: 'From IP: 192.168.1.100',
  },
  {
    id: '5',
    timestamp: '2023-10-25 11:45:10',
    action: 'Property Added',
    affectedItem: '456 Oak Avenue',
  },
];

export const userRoles = ['Administrator', 'Project Manager', 'Viewer'];
